var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 150,
    viewBox: "0 0 139 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4356 62.8588L80.325 62.1706V104.994L68.2375 107.124L68.2079 61.1118L57.9359 60.2059V43.3412L88.4356 48.6441V62.8588ZM111.454 99.5765L104.281 100.815L103.444 94.5735L96.4574 95.4765L95.5822 102.344L86.3421 103.971L95.4905 49.9706L104.175 51.4706L111.454 99.5765ZM102.167 84.0235L100.245 67.5353H99.8252L97.8796 84.2735L102.167 84.0235ZM62.2056 149.797C103.56 149.797 137.072 116.262 137.072 74.9C137.075 33.5294 103.563 0 62.2085 0C36.2802 0 13.4388 13.1853 0 33.2235L20.748 36.8618L26.4576 80.3324C26.4783 80.2618 26.8716 80.3059 26.8716 80.3059L33.1341 39.0235L53.8969 42.6382V109.647L40.7923 111.929V83.1353C40.7923 83.1353 41.2772 70.7323 40.9904 68.6118C40.9904 68.6118 40.4197 68.6265 40.4109 68.5794L32.593 113.391L19.5742 115.676L10.0059 67.4059L9.4293 67.3647C9.22528 69.1118 10.1301 84.2588 10.1301 84.2588V117.326L1.57303 118.824C15.1833 137.588 37.2678 149.797 62.2056 149.797Z",
    fill: "#0039A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.971,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/Logo_blue.c8894206ede62119b7df8fa6ffa767ea.svg";
export { ForwardRef as ReactComponent };